<template>
  <div>
    <div class="border-b-2 border-grey-200 py-6">
      <Container use-full-width>
        <div class="flex items-start justify-between gap-10">
          <!-- FILTER CATEGORY DESKTOP -->
          <AnimatedContainer :stagger="0.05">
            <ul class="flex flex-wrap gap-x-12 gap-y-3 self-stretch pt-2 max-lg:hidden">
              <li v-for="category in categories" :key="category?.id" class="slide-left">
                <button
                  :class="{ 'text-primary-900': filter?.category === category?.slug }"
                  class="font-semibold transition-colors typo-subtitle"
                  type="button"
                  @click="onFilterCategory(category?.slug || '')"
                >
                  {{ category?.title }}
                </button>
              </li>
            </ul>
          </AnimatedContainer>

          <!-- FILTER CATEGORY MOBILE -->
          <SingleSelect
            title="magazine-filter-category"
            :model-value="categories.find((category) => category?.slug === filter?.category) || undefined"
            placeholder="auswählen"
            class="mt-0.5 pt-2 lg:hidden"
            :options="categories || []"
            @update:model-value="filter ? filter.category = $event.slug : null"
          />

          <AppButton class="shrink-0" @click="isTagFilterOpen = !isTagFilterOpen">
            <template #icon>
              <Transition tag="div" name="fade" mode="out-in">
                <IconClose v-if="isTagFilterOpen" class="size-7" />
                <IconFilter v-else class="size-7" />
              </Transition>
            </template>
          </AppButton>
        </div>
      </Container>
    </div>
    <!-- FILTER TAGS -->
    <div ref="tagFilter" class="overflow-hidden shadow-md" :class="{ 'h-0': !isMounted }">
      <Container use-full-width class="py-9">
        <h3 class="mb-4 font-semibold typo-subtitle">
          {{ $t('tags') }}
        </h3>
        <ul class="flex flex-wrap gap-2 xl:max-w-[75%]">
          <li v-for="tag in tags" :key="tag?.id">
            <button type="button" @click="onFilterTags(tag?.slug || '')">
              <AppTag :active="filter?.tag === tag?.slug">
                {{ tag?.title }}
              </AppTag>
            </button>
          </li>
        </ul>

        <!-- AMOUNT ARTICLES FOUND -->
        <div class="mt-6 text-grey-300 typo-subtitle">
          {{ $t('articles_found', amountEntries) }}
        </div>
      </Container>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { MainComponentsOverviewMagazineFragment } from '#gql'
import type { FilterType } from '~/components/main-components/OverviewMagazine.vue'

withDefaults(
  defineProps<{
    categories: MainComponentsOverviewMagazineFragment['magazine_categories']
    tags: MainComponentsOverviewMagazineFragment['magazine_tags']
    amountEntries: number
  }>(),
  {
    categories: () => [],
    tags: () => [],
    amountEntries: 0,
  },
)

const filter = defineModel<FilterType>()

// Collapse Tags
const tagFilter = ref<HTMLElement | undefined>(undefined)
const isTagFilterOpen = useCollapse(tagFilter, {
  duration: 300,
  initiallyClosed: !filter.value?.tag,
})

function onFilterCategory(slug: string) {
  if (!filter.value) {
    return
  }
  if (filter.value.category === slug) {
    filter.value.category = 'all'

    return
  }
  filter.value.category = slug
}

function onFilterTags(slug: string) {
  if (!filter.value) {
    return
  }
  if (filter.value.tag === slug) {
    filter.value.tag = null
    return
  }
  filter.value.tag = slug
}

const isMounted = ref(!!filter.value?.tag)
onMounted(() => {
  // To hide the collapse before it is mounted (workaround) when it should be collapsed initially
  isMounted.value = true
})
</script>
